export const aiTargets = [
  { name: 'ChatGPT', url: (q: string) => `https://chatgpt.com/?q=${encodeURIComponent(q)}` },
  { name: 'Claude', url: (q: string) => `https://claude.ai/new?q=${encodeURIComponent(q)}` },
  { name: 'Gemini', url: () => 'https://gemini.google.com/app' },
];

export const leadResponsePrompt = {
  n: 34,
  title: 'Instant Lead Response',
  text: `Act as a professional real estate lead-conversion assistant. Create a concise, personalized first response to a new [BUYER/SELLER] lead who contacted me about [PROPERTY / SERVICE]. My market is [CITY / AREA]. The lead's message is: [PASTE MESSAGE].

Write a natural response that acknowledges their specific inquiry, establishes credibility, asks no more than [NUMBER] useful qualification questions, and creates a clear next step without sounding pushy or automated.

Keep the tone [PROFESSIONAL / FRIENDLY / CONSULTATIVE]. Do not invent property details, market statistics or client information.`,
};

type DemoSection = { heading: string; intro?: string; lines: string[] };

export const demoOutput: { title: string; sections: DemoSection[] } = {
  title: 'New Lead Response',
  sections: [
    { heading: 'Opening', lines: ['Personalized acknowledgment of the lead’s specific inquiry.'] },
    {
      heading: 'Qualification',
      intro: 'Relevant questions designed to understand:',
      lines: ['Timeline', 'Property needs', 'Location', 'Budget / priorities'],
    },
    { heading: 'Next Step', lines: ['A natural invitation to continue the conversation or schedule the appropriate next step.'] },
  ],
};

export const promptSamples = [
  { n: '01', volume: 'Leads', title: 'Local Market Lead Magnet', desc: 'Create a lead magnet around a specific local market.' },
  { n: '17', volume: 'Listings', title: 'MLS Listing Description', desc: 'Transform verified property information into a professional listing description.' },
  { n: '34', volume: 'Conversion', title: 'Instant Lead Response', desc: 'Respond quickly and professionally to a new inquiry.' },
  { n: '51', volume: 'Negotiation', title: 'Commission Objection', desc: 'Prepare a professional response to a client questioning your commission.' },
  { n: '68', volume: 'Follow-Up', title: 'New Lead 7-Day Sequence', desc: 'Build a structured follow-up sequence for a new prospect.' },
  { n: '90', volume: 'Authority', title: '30-Day Content Strategy', desc: 'Build a month of strategic REALTOR® content.' },
];
